import { MbExpandablePanel, MbTooltipTrigger, MbIcon } from '@am/moebius';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { PricingExpandableComponent } from '@commons/price/pricing-expandable/pricing-expandable.component';
import { PriceService } from '@core/services/price.service';
import { ReqService } from '@core/services/req.service';
import { IRate } from '@core/models/Rate/Rate.interface';
import { MealPlan } from '../../shared/enums/meal-plan.enum';
import { CurrencyCode } from '../../shared/enums/currency-code.enum';
import { MealPlanDetail } from '@core/models/MealPlan/MealPlan.model';
import { Supplements } from '@core/models/Supplement/Supplements.model';
import { EllipsisPipe } from '../../shared/pipes/ellipsis.pipe';
import { CurrencyPipe } from '../../shared/pipes/currency.pipe';
import { PricingExpandableComponent as PricingExpandableComponent_1 } from './pricing-expandable/pricing-expandable.component';
import { BasicSkeletonComponent } from '../basic-skeleton/basic-skeleton.component';

@Component({
    selector: 'am-price',
    templateUrl: './price.component.html',
    styleUrls: ['./price.component.scss'],
    standalone: true,
    imports: [
        MbExpandablePanel,
        MbTooltipTrigger,
        BasicSkeletonComponent,
        MbIcon,
        PricingExpandableComponent_1,
        CurrencyPipe,
        EllipsisPipe,
    ],
})
export class PriceComponent implements OnInit, AfterViewInit {
  @ViewChild('pricingExpandable')
  public breakdownExpandable: PricingExpandableComponent;

  @ViewChild('detailRate')
  public detailRate: MbExpandablePanel;
  @Input()
  public fop = '';

  @Input() set rateSelected(rateSelected: IRate) {
    this.rate = rateSelected;
    this.createValues();
  }

  @Input() expandable = false;
  @Input() isDisney = false;
  @Input() showAmountTotal = false;
  @Input() quantityNights = 0;
  @Input() guests = 0;
  @Input() quantityRooms = 0;
  @Input() isArgentinian = false;
  @Input() showPriceSkeleton = false;
  @Input() fixedPricePerNight: number = null;

  @Input() set tickets(tickets: Supplements) {
    if (tickets) {
      this.ticketDays = tickets.days;
      this.ticketName = tickets.description.split('with')[1];
      this.ticketAmount = tickets.total_amount ?? tickets.amount;
    } else {
      if (this.ticketDays > 0) {
        this.ticketDays = 0;
        this.ticketName = '';
        this.ticketAmount = 0;
      }
    }
    this.createValues();
  }

  @Input()
  public set mealPlan(mealPlan: MealPlanDetail) {
    this.mealPlanSelected = mealPlan;
  }

  @Input()
  public nameRoom = '';

  showDiscountPrice = false;
  amountPerNight: any = null;
  amountTotal: any;
  ticketDays = 0;
  ticketName = '';
  ticketAmount = 0;
  isBreakdownDetailExpanded = false;
  rate: IRate;
  mealPlanSelected: MealPlanDetail = { code: MealPlan.ROOM_ONLY, description: '' };
  currencyCode = 'ARS';
  currencyLabel = '$';
  isExperts = false;

  public readonly MEAL_PLAN = MealPlan;

  constructor(
    private priceService: PriceService,
    private cdr: ChangeDetectorRef,
    private reqService: ReqService,
  ) {
    this.isExperts = this.reqService.isExperts();
  }

  ngOnInit() {
    this.setCurrencyCode();
  }

  ngAfterViewInit(): void {
    if (this.detailRate !== undefined) {
      if (this.expandable) {
        this.detailRate.close();
      } else {
        this.detailRate.open();
      }

      this.cdr.detectChanges();
    }
  }

  private showAmountPerNight(rate) {
    return {
      without_promo: this.priceService.getPriceWithoutDiscount(
        rate,
        'NIGHT',
        this.showAmountTotal,
      ),
      total: this.priceService.getPrice(
        rate,
        'NIGHT',
        this.showAmountTotal,
        this.isDisney,
        this.ticketAmount,
      ),
      withTaxes: this.priceService.getPrice(
        rate,
        'NIGHT',
        this.showAmountTotal,
        false,
        this.ticketAmount,
      ),
    };
  }

  private showAmount(rate) {
    return {
      without_promo: this.priceService.getPriceWithoutDiscount(
        rate,
        'TOTAL',
        this.showAmountTotal,
      ),
      total: this.priceService.getPrice(
        rate,
        'TOTAL',
        this.showAmountTotal,
        this.isDisney,
      ),
      withTaxes: this.priceService.getPrice(rate, 'TOTAL', this.showAmountTotal),
    };
  }

  expandBreakdownDetail() {
    if (!this.isBreakdownDetailExpanded) {
      this.breakdownExpandable.toggle();
      this.isBreakdownDetailExpanded = true;
    }
  }

  createValues() {
    if (this.rate !== undefined) {
      this.showDiscountPrice =
        this.rate.price.discount.amount && this.rate.price.discount.percentage >= 5;
      this.amountPerNight = this.showAmountPerNight(this.rate);
      this.amountTotal = this.showAmount(this.rate);
    }
  }

  showDetail() {
    if (this.detailRate.expanded()) {
      this.detailRate.close();
    } else {
      this.detailRate.open();
    }
  }

  private setCurrencyCode(): void {
    if (this.rate.price.currency.code.toUpperCase() === CurrencyCode.USD) {
      this.currencyCode = 'USD';
      this.currencyLabel = 'u$s';
    }
  }
}
